import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Header from './header'
import SetMetatags from '../../metatag'
import Topmenu from './topmenu'
import Footer from './footer'
import _ from 'lodash'
import { gaEvent } from '../../ga/analytics'
import { CATEGORY_GOTO_TOP } from '../../ga/constant'
import { MainEL } from '../style/global'

class Layout extends Component {
  static propTypes = {
    match: PropTypes.shape({ params: PropTypes })
  }
  constructor(props) {
    super(props)
    this.state = {
      intervalId: 0,
      offset: 0
    }
  }

  componentDidMount() {
    this.goTop()
  }

  sendToGa = () => {
    gaEvent(CATEGORY_GOTO_TOP, this.props.page)
  }

  componentWillUnmount() {
    this.goTop()
  }

  goTop = () => {
    window.addEventListener(
      'scroll',
      _.debounce(() => {
        let supportPageOffset = window.pageXOffset !== undefined
        let isCSS1Compat = (document.compatMode || '') === 'CSS1Compat'
        let scroll = {
          x: supportPageOffset
            ? window.pageXOffset
            : isCSS1Compat
              ? document.documentElement.scrollLeft
              : document.body.scrollLeft,
          y: supportPageOffset
            ? window.pageYOffset
            : isCSS1Compat
              ? document.documentElement.scrollTop
              : document.body.scrollTop
        }
        this.setState({ offset: scroll.y })
      })
    )
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId)
    }
    window.scroll(0, window.pageYOffset - 50)
  }

  scrollToTop() {
    this.sendToGa()
    let intervalId = setInterval(this.scrollStep.bind(this), 5)
    this.setState({ intervalId: intervalId })
  }

  render() {
    
    const { offset } = this.state
    const fixedHead   = (offset>=51)?true:false;
    return (
      <div>
        { this.props.loading ? (
          <div className="__loading">
            <img src='/src/images/Spinner-1s-200px.gif' alt="" />
          </div>
        ) : null }
        <Header {...this.props} />
        <SetMetatags {...this.props} />
        <Topmenu {...this.props} fixedHead={fixedHead} />
        <MainEL fixedHead={fixedHead} >
          {this.props.children}
          {offset > 400 ? (
            <button
              onClick={() => this.scrollToTop()}
              className="topBtn"
              title="Go to top"
            >
              <i className="ion-arrow-up-a" />
            </button>
          ) : (
            ''
          )}
        </MainEL>
        <Footer {...this.props} />
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/layouts/index.jsx